module.exports = __webpack_public_path__ + "static/chattan-76ced90070e1aec5bba6669d07653361.jpg";